import {
  adaptLoyaltyMessage,
  getLoyaltyMessage,
} from 'stores/adapters/bex-api/migration-adapters/property-info/rate-plan-adapters/loyalty-message-adapter';
import {
  adaptMarketingSection,
  getMarketingSection,
} from 'stores/adapters/bex-api/migration-adapters/property-info/rate-plan-adapters/marketing-section-adapter';
import { adaptRatePlanBadgeModel } from 'stores/adapters/bex-api/migration-adapters/property-info/rate-plan-adapters/rate-plan-badge-adapter';
import { adaptRatePlanDataAttributes } from 'stores/adapters/bex-api/migration-adapters/property-info/rate-plan-adapters/data-attributes-adapter';
import {
  adaptRatePlanTitle,
  getRatePlanTitle,
} from 'stores/adapters/bex-api/migration-adapters/property-info/rate-plan-adapters/rate-plan-title-adapter';
import { adaptCancellationPolicy } from 'stores/adapters/bex-api/migration-adapters/property-info/property-cancellation-policy-adapter';
import { adaptPaymentPlans } from 'stores/adapters/bex-api/migration-adapters/property-info/rate-plan-adapters/payment-plan-adapter';
import { adaptPrice } from 'stores/adapters/bex-api/migration-adapters/property-info/rate-plan-adapters/price-adapter';
import { mapMessageModel } from 'stores/adapters';

import { AmenityViewModel, RatePlanViewModel } from 'src/common/models';

import { adaptEtp, adaptMarketingSectionEtp } from './payment-policy-adapter';

export const adaptRatePlans = (ratePlans): RatePlanViewModel[] => ratePlans?.map(ratePlan => adaptRatePlan(ratePlan)).filter(Boolean);

export const adaptRatePlan = (ratePlan): RatePlanViewModel => ({
  ratePlanBadgeModel: adaptRatePlanBadgeModel(ratePlan),
  ratePlanCode: ratePlan?.id,
  priceChangeMessage: ratePlan.headerMessage?.value,
  marketingSection: adaptMarketingSection(getMarketingSection(ratePlan)),
  ratePlanLoyaltyModel: adaptLoyaltyMessage(getLoyaltyMessage(ratePlan)),
  price: adaptPrice(ratePlan),
  cancellationPolicy: adaptCancellationPolicy(ratePlan),
  dataAttributes: adaptRatePlanDataAttributes(ratePlan),
  priceBreakDownSummary: ratePlan.priceDetails?.[0]?.priceBreakDownSummary,
  paymentPlans: adaptPaymentPlans(ratePlan.priceDetails),
  amenities: adaptRatePlanAmenities(ratePlan.amenities),
  highlightedMessages: ratePlan.highlightedMessages,
  ratePlanTitle: adaptRatePlanTitle(getRatePlanTitle(ratePlan)),
  etpCancellationMessage: mapMessageModel(ratePlan.etpDialogTopMessage, ratePlan.etpDialogTopMessage?.__typename),
  etp: adaptEtp(ratePlan.paymentPolicy),
  marketingEtpSection: adaptMarketingSectionEtp(ratePlan.paymentPolicy),
  reserveCallToAction: ratePlan.reserveCallToAction,
});

export const adaptRatePlanAmenities = (amenities): AmenityViewModel[] => {
  if (!amenities || amenities.length === 0) {
    return [];
  }

  return amenities.map(amenity => {
    if (typeof amenity.icon === 'string') {
      return amenity;
    }

    return { ...amenity, icon: amenity.icon?.id?.toLowerCase() };
  });
};
